import { useEffect } from 'react';
import {
  CONFIRMATION,
  CUSTOMIZING,
  USER_ONBOARDING_CUSTOMIZING,
} from '../helpers/constants/newMemberStates';
import { findNewMemberStateIndex, newMemberStateUrlMap } from '../helpers/newMemberStateUrlMap';

export function useNmfRedirect(
  newMemberState: string | null | undefined,
  lastVisitedCustomizeQuestionId: number | undefined,
  baseUrl: string,
  timerType: string | undefined,
) {
  useEffect(() => {
    if (!newMemberState) {
      return;
    }
    const stateIndex = findNewMemberStateIndex(newMemberState);
    if (stateIndex === -1) {
      return;
    }
    const stateInfo = newMemberStateUrlMap[stateIndex];
    const stateUrls = timerType === 'REACTIVATION' ? stateInfo.rmUrls : stateInfo.nmUrls;
    const validUrls = newMemberStateUrlMap
      .slice(0, stateIndex + 1)
      .reduce(
        (urls, curr) =>
          timerType === 'REACTIVATION' ? [...urls, ...curr.rmUrls] : [...urls, ...curr.nmUrls],
        [] as string[],
      );

    const currentUrl = window.location.href;

    if (!validUrls) {
      return;
    }

    const currentUrlIsValid = !!validUrls.filter((validUrl) => {
      const urlHasSubstring = currentUrl.includes(validUrl);
      // For performance and simplicity, just treat confirmation page as a special exception
      if (
        newMemberState !== CONFIRMATION &&
        urlHasSubstring &&
        currentUrl.includes('/confirmation')
      ) {
        return false;
      }
      return urlHasSubstring;
    }).length;
    if (!currentUrlIsValid) {
      const isCustomizePage = [CUSTOMIZING, USER_ONBOARDING_CUSTOMIZING].includes(
        newMemberState ?? '',
      );

      window.location.href =
        baseUrl +
        stateUrls[0] +
        (isCustomizePage && !!lastVisitedCustomizeQuestionId
          ? `?q=${lastVisitedCustomizeQuestionId}`
          : '');
    }
  }, [newMemberState, baseUrl, lastVisitedCustomizeQuestionId, timerType]);
}
